import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { CARD_MARGIN } from './consts';
import { theme } from '../theme';
export const RequiredFieldPrompt = () => {
    return (<View style={styles.row}>
      <Text style={styles.asterisk}>*</Text>
      <Text>Required field</Text>
    </View>);
};
const styles = StyleSheet.create({
    row: {
        marginLeft: CARD_MARGIN,
        flexDirection: 'row',
    },
    asterisk: {
        color: theme.colors.dangerText,
        marginRight: 5,
    },
});
